export default "__VITE_ASSET__1028e3eb__"